import { vehicleUseHistoryModel } from './vehicle-use-history-model'
import { z } from 'my-zod'

export const vehicleUseHistorySystemView = vehicleUseHistoryModel
export type vehicleUseHistorySystemView = z.infer<typeof vehicleUseHistorySystemView>
